"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactWebcam = _interopRequireDefault(require("react-webcam"));
var _noop2 = _interopRequireDefault(require("lodash/noop"));
var _hooks = require("../../hooks");
var _i18n = _interopRequireDefault(require("../../utils/i18n"));
var _ = require("./..");
var Icons = _interopRequireWildcard(require("../../Icons"));
var _Loader = _interopRequireDefault(require("../../Loader"));
var _config = require("./config");
require("./Camera.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ActionModal = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return _interopRequireWildcard(require("../../Modal/ActionModal"));
  });
});
function Camera(_ref) {
  var _ref$allScreen = _ref.allScreen,
    allScreen = _ref$allScreen === void 0 ? true : _ref$allScreen,
    _ref$nativeOptions = _ref.nativeOptions,
    nativeOptions = _ref$nativeOptions === void 0 ? {} : _ref$nativeOptions,
    _ref$audio = _ref.audio,
    audio = _ref$audio === void 0 ? false : _ref$audio,
    _ref$videoConstraints = _ref.videoConstraints,
    videoConstraints = _ref$videoConstraints === void 0 ? _config.VIDEO_CONSTRAINTS_DEFAULT : _ref$videoConstraints,
    _ref$screenshotFormat = _ref.screenshotFormat,
    screenshotFormat = _ref$screenshotFormat === void 0 ? _config.SCREENSHOT_FORMAT_DEFAULT : _ref$screenshotFormat,
    _ref$showSelectedImag = _ref.showSelectedImage,
    showSelectedImage = _ref$showSelectedImag === void 0 ? false : _ref$showSelectedImag,
    _ref$getImages = _ref.getImages,
    getImages = _ref$getImages === void 0 ? _noop2["default"] : _ref$getImages,
    _ref$onSend = _ref.onSend,
    onSend = _ref$onSend === void 0 ? _noop2["default"] : _ref$onSend,
    _ref$onMoreImages = _ref.onMoreImages,
    onMoreImages = _ref$onMoreImages === void 0 ? _noop2["default"] : _ref$onMoreImages,
    _ref$onError = _ref.onError,
    onError = _ref$onError === void 0 ? _noop2["default"] : _ref$onError,
    _ref$onChangeShowSele = _ref.onChangeShowSelected,
    onChangeShowSelected = _ref$onChangeShowSele === void 0 ? _noop2["default"] : _ref$onChangeShowSele,
    _ref$onPermissionsErr = _ref.onPermissionsError,
    onPermissionsError = _ref$onPermissionsErr === void 0 ? _noop2["default"] : _ref$onPermissionsErr,
    _ref$customImage = _ref.customImage,
    customImage = _ref$customImage === void 0 ? null : _ref$customImage,
    _ref$swiper = _ref.swiper,
    swiper = _ref$swiper === void 0 ? true : _ref$swiper,
    _ref$customListOfImag = _ref.customListOfImages,
    customListOfImages = _ref$customListOfImag === void 0 ? null : _ref$customListOfImag,
    _ref$customListOfSele = _ref.customListOfSelectedImages,
    customListOfSelectedImages = _ref$customListOfSele === void 0 ? null : _ref$customListOfSele,
    _ref$onlyCustomImage = _ref.onlyCustomImage,
    onlyCustomImage = _ref$onlyCustomImage === void 0 ? false : _ref$onlyCustomImage,
    _ref$showCameraButton = _ref.showCameraButton,
    showCameraButton = _ref$showCameraButton === void 0 ? true : _ref$showCameraButton,
    children = _ref.children;
  var _useState = (0, _react.useState)(null),
    _useState2 = _slicedToArray(_useState, 2),
    actualImage = _useState2[0],
    setActualImage = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showListOfImages = _useState4[0],
    setShowListOfImages = _useState4[1];
  var _useState5 = (0, _react.useState)([]),
    _useState6 = _slicedToArray(_useState5, 2),
    listOfImages = _useState6[0],
    setListOfImages = _useState6[1];
  var _useState7 = (0, _react.useState)([]),
    _useState8 = _slicedToArray(_useState7, 2),
    listOfSelectedImages = _useState8[0],
    setListOfSelectedImages = _useState8[1];
  var _useState9 = (0, _react.useState)(0),
    _useState10 = _slicedToArray(_useState9, 2),
    swiperImage = _useState10[0],
    setSwiperImage = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = _slicedToArray(_useState11, 2),
    cameraWithZoom = _useState12[0],
    setCameraWithZoom = _useState12[1];
  var _useState13 = (0, _react.useState)({}),
    _useState14 = _slicedToArray(_useState13, 2),
    zoomConfig = _useState14[0],
    setZoomConfig = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    activeFlash = _useState16[0],
    setActiveFlash = _useState16[1];
  var _useState17 = (0, _react.useState)(false),
    _useState18 = _slicedToArray(_useState17, 2),
    hasNotPermissions = _useState18[0],
    setHasNotPermissions = _useState18[1];
  var webcamRef = (0, _react.useRef)(null);
  (0, _hooks.useScroll)({
    disableScroll: allScreen
  });
  var handleClickCapture = (0, _react.useCallback)(function () {
    var imgBase64 = webcamRef.current.getScreenshot();
    if (imgBase64) {
      setActualImage(imgBase64);
      if (showListOfImages) {
        var validList = listOfImages.length < 5;
        var finalList = validList ? listOfImages : listOfImages.slice(0, -1);
        setListOfImages([].concat(_toConsumableArray(finalList), [imgBase64]));
      }
    }
  }, [webcamRef, listOfImages, showListOfImages]);
  var handleClickMoreImages = (0, _react.useCallback)(function () {
    onMoreImages();
    setShowListOfImages(true);
  }, [onMoreImages]);
  var handleClickSend = (0, _react.useCallback)(function () {
    onSend({
      actualImage: actualImage,
      listOfImages: listOfImages,
      listOfSelectedImages: listOfSelectedImages
    });
  }, [onSend, actualImage, listOfImages, listOfSelectedImages]);
  var handleError = function handleError(error) {
    console.error(error);
    // eslint-disable-next-line no-shadow
    var hasNotPermissions = error.toString().includes(_config.ERRORS.PERMISSIONS_DENIED);
    if (hasNotPermissions) {
      setHasNotPermissions(true);
      return;
    }
    onError(error);
  };
  var handleChangeCurrentPage = (0, _react.useCallback)(function (currentPage) {
    setSwiperImage(currentPage);
  }, []);
  var handleClickImage = (0, _react.useCallback)(function (status, image) {
    var list = [];
    var filterList = function filterList() {
      return listOfSelectedImages.filter(function (selectedImage) {
        return selectedImage !== image;
      });
    };
    if (status) {
      list = filterList();
      list.push(image);
    } else list = filterList();
    setListOfSelectedImages(list);
  }, [listOfSelectedImages]);
  (0, _react.useEffect)(function () {
    getImages(actualImage, listOfImages);
  }, [actualImage, listOfImages, getImages]);
  (0, _react.useEffect)(function () {
    if (customListOfImages) {
      setListOfImages(customListOfImages);
      setListOfSelectedImages(customListOfImages);
      setActualImage(null);
    }
  }, [customListOfImages]);
  (0, _react.useEffect)(function () {
    if (customListOfSelectedImages) {
      setListOfSelectedImages(customListOfSelectedImages);
    }
  }, [customListOfSelectedImages]);
  var imageSrc = (0, _react.useMemo)(function () {
    var validListOfSelectedImgs = swiper && listOfSelectedImages.length > 0;
    if (onlyCustomImage) {
      return validListOfSelectedImgs ? listOfSelectedImages[swiperImage] : customImage;
    }
    return validListOfSelectedImgs ? listOfSelectedImages[swiperImage] : customImage || actualImage || '';
  }, [swiperImage, listOfSelectedImages, actualImage, customImage, onlyCustomImage]);
  var getValidRenderImage = function getValidRenderImage() {
    var validListOfSelectedImgs = swiper && listOfSelectedImages.length > 0;
    if (onlyCustomImage) {
      return customImage || validListOfSelectedImgs;
    }
    return customImage || actualImage || validListOfSelectedImgs;
  };
  var ADVANCED_FUNCTIONALITIES = (0, _react.useMemo)(function () {
    return [{
      type: _config.ZOOM,
      setConfig: setZoomConfig,
      setExist: setCameraWithZoom
    }];
  }, []);
  var handleDoubleClick = (0, _react.useCallback)(function () {
    setActiveFlash(function (currentActiveFlash) {
      return !currentActiveFlash;
    });
  }, []);
  (0, _react.useEffect)(function () {
    if (webcamRef.current && webcamRef.current.stream) {
      var track = (0, _config.getStreamTrack)(webcamRef.current.stream);
      var constraints = {
        advanced: [{
          torch: activeFlash
        }]
      };
      track.applyConstraints(constraints).then(function () {
        return console.log('Flash active');
      })["catch"](function (error) {
        return console.error('Flash error ', error);
      });
    }
  }, [webcamRef.current, activeFlash]);
  var handleUserMedia = (0, _react.useCallback)(function (stream) {
    var video = document.querySelector('video');
    video.srcObject = stream;
    var track = (0, _config.getStreamTrack)(stream);
    var capabilities = track.getCapabilities();
    var settings = track.getSettings();
    ADVANCED_FUNCTIONALITIES.forEach(function (_ref2) {
      var type = _ref2.type,
        setConfig = _ref2.setConfig,
        setExist = _ref2.setExist;
      if (!(type in settings)) {
        console.error("Camera does not support ".concat(type, "."));
        return;
      }
      if (type === _config.ZOOM) {
        setExist(true);
        setConfig(function () {
          return {
            min: capabilities[type].min,
            max: capabilities[type].max,
            step: capabilities[type].step,
            onChange: function () {
              var _onChange = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(currentValue) {
                var constraints;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      constraints = {
                        advanced: [_defineProperty({}, type, currentValue)]
                      };
                      _context.next = 4;
                      return track.applyConstraints(constraints);
                    case 4:
                      _context.next = 9;
                      break;
                    case 6:
                      _context.prev = 6;
                      _context.t0 = _context["catch"](0);
                      console.error("Error apply ".concat(type, " "), _context.t0);
                    case 9:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 6]]);
              }));
              function onChange(_x) {
                return _onChange.apply(this, arguments);
              }
              return onChange;
            }()
          };
        });
      }
    });
  }, [ADVANCED_FUNCTIONALITIES]);
  var handlePermissionsError = function handlePermissionsError() {
    setHasNotPermissions(false);
    onPermissionsError();
  };
  var ViewImagesRender = /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-image"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-image__container"
  }, getValidRenderImage() ? /*#__PURE__*/_react["default"].createElement("img", {
    src: imageSrc,
    className: "view-image__image",
    alt: ""
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-image__".concat(children ? 'image' : 'not-image')
  }, children), /*#__PURE__*/_react["default"].createElement("div", {
    className: "view-image__functions-container"
  }, showCameraButton && /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "btn m-0 p-0 view-image__functions-container--camera-button",
    onClick: onChangeShowSelected,
    id: "deliveryVehicleParts_camera-button"
  }, /*#__PURE__*/_react["default"].createElement(Icons.Camera, {
    width: _config.ICON_WIDTH
  })))), listOfSelectedImages.length > 0 && swiper && /*#__PURE__*/_react["default"].createElement(_.PageNavigator, {
    containerClassName: "view-image__paginator-container mt-2",
    elements: listOfSelectedImages,
    onChangeCurrentPage: handleChangeCurrentPage
  }));
  var webcamRender = /*#__PURE__*/_react["default"].createElement(_reactWebcam["default"], _extends({
    ref: webcamRef,
    videoConstraints: videoConstraints,
    audio: audio,
    screenshotFormat: screenshotFormat,
    onUserMediaError: handleError,
    onUserMedia: handleUserMedia,
    onDoubleClick: handleDoubleClick
  }, nativeOptions));
  var CameraRender = /*#__PURE__*/_react["default"].createElement("div", {
    className: "all-container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "camera"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "camera__webcam"
  }, cameraWithZoom ? /*#__PURE__*/_react["default"].createElement(_.Slider, _extends({
    vertical: true,
    allScreen: true
  }, zoomConfig), webcamRender) : webcamRender), /*#__PURE__*/_react["default"].createElement("div", {
    className: "camera__functions__container"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "container-fluid"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "row d-flex justify-content-center"
  }, (listOfImages.length > 0 || actualImage) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-4 d-flex justify-content-center align-items-center"
  }, showListOfImages ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "camera__list-of-images"
  }, listOfImages.map(function (image, i) {
    return /*#__PURE__*/_react["default"].createElement(_.SmallImage, {
      key: image,
      image: image,
      alt: "vehicle ".concat(i + 1),
      onClick: handleClickImage,
      active: listOfSelectedImages.find(function (selectedImage) {
        return selectedImage === image;
      })
    });
  })) : /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn camera__functions__item",
    id: "deliveryVehicleParts_camera-button_moreImages",
    onClick: handleClickMoreImages,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(Icons.MoreImages, {
    width: _config.ICON_WIDTH
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-4 d-flex justify-content-center align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn camera__functions__item",
    id: "deliveryVehicleParts_camera-button_capture",
    onClick: handleClickCapture,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(Icons.Camera, {
    width: _config.ICON_WIDTH
  }))), (listOfImages.length > 0 || actualImage) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-4 d-flex justify-content-center align-items-center"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn camera__functions__item",
    id: "deliveryVehicleParts_camera-button_send",
    onClick: handleClickSend,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(Icons.Send, {
    width: _config.ICON_WIDTH
  }))))))));
  var AllRender = showSelectedImage ? ViewImagesRender : CameraRender;
  return /*#__PURE__*/_react["default"].createElement(_react.Suspense, {
    fallback: /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
      show: true
    })
  }, hasNotPermissions && /*#__PURE__*/_react["default"].createElement(ActionModal, {
    icon: /*#__PURE__*/_react["default"].createElement(Icons.IcoCarError, null),
    open: hasNotPermissions,
    success: false,
    title: (0, _i18n["default"])('CAMERA__PERMISSIONS_ERROR__TITLE'),
    actionLabel: (0, _i18n["default"])('COMMONS__CLOSE__TEXT'),
    message: (0, _i18n["default"])('CAMERA__PERMISSIONS_ERROR__MESSAGE'),
    closeButton: false,
    onAction: handlePermissionsError,
    modalType: "confirmation"
  }), allScreen ? /*#__PURE__*/_react["default"].createElement(_.Portal, null, AllRender) : AllRender);
}
Camera.propTypes = {
  allScreen: _propTypes["default"].bool,
  // eslint-disable-next-line react/forbid-prop-types
  nativeOptions: _propTypes["default"].object,
  audio: _propTypes["default"].bool,
  videoConstraints: _propTypes["default"].shape({
    width: _propTypes["default"].number,
    height: _propTypes["default"].number,
    facingMode: _propTypes["default"].string,
    zoom: _propTypes["default"].bool
  }),
  screenshotFormat: _propTypes["default"].string,
  showSelectedImage: _propTypes["default"].bool,
  getImage: _propTypes["default"].func,
  onSend: _propTypes["default"].func,
  onMoreImages: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onChangeShowSelected: _propTypes["default"].func,
  onPermissionsError: _propTypes["default"].func,
  customImage: _propTypes["default"].string,
  swiper: _propTypes["default"].bool,
  customListOfImages: _propTypes["default"].arrayOf(_propTypes["default"].string),
  customListOfSelectedImages: _propTypes["default"].arrayOf(_propTypes["default"].string),
  onlyCustomImage: _propTypes["default"].bool,
  showCameraButton: _propTypes["default"].bool,
  children: _propTypes["default"].node
};

// eslint-disable-next-line react/destructuring-assignment
var _default = exports["default"] = function _default(props) {
  return props.show ? /*#__PURE__*/_react["default"].createElement(Camera, props) : null;
};